import * as React from "react";
import { BaseDict } from "../../../dict";
import { getDictPhrase } from "../../../../../helpers";

export const renderGameState = (isLive: boolean, eventId: string, gamePart: string, gameTime: string, componentPrefix: string, dict: BaseDict) =>
    isLive &&
        <div key={eventId} className={`rj-ev-list__${componentPrefix}__game-state`} data-uat={`div-ev-list-${componentPrefix}-game-state`}>
            <span className={`rj-ev-list__${componentPrefix}__game-part`} data-uat={`span-ev-list-${componentPrefix}-game-state-part`}>{getDictPhrase(dict, gamePart)}</span>
            <span className={`rj-ev-list__${componentPrefix}__game-time`} data-uat={`span-ev-list-${componentPrefix}-game-state-time`}>{gameTime ? dict.ClockMins.format(gameTime) : ""}</span>
        </div>;